import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { Checkbox } from "@evergis/ui";
import { FeatureDc } from "@evergis/api";

import { LegendToggler } from "../../../LayerList/styled";
import { checkEqualOrIncludes } from "../../utils/checkEqualOrIncludes";
import { getConfigFilter } from "../../utils/getConfigFilter";
import { getDataSource } from "../../utils/getDataSource";
import { getFilterValue } from "../../utils/getFilterValue";
import { getListOptions } from "../../utils/getListOptions";
import { useWidgetContext } from "../../../Dashboard/hooks/useWidgetContext";
import { useShownOtherItems } from "../../hooks/useShownOtherItems";
import { WidgetFilterProps } from "./types";
import { SelectedFilters } from "../../types";

export const CheckboxFilter: FC<WidgetFilterProps> = ({ type, filter, config, elementConfig }) => {
  const { t } = useTranslation("featureCard");
  const { filters, dataSources, changeFilters } = useWidgetContext(type);

  const { filters: configFilters } = config;
  const { options } = elementConfig || {};
  const { shownItems } = options || {};
  const { filterName } = filter.options;

  const { sliceItems, showMore, onShowMore } = useShownOtherItems(options);
  const configFilter = getConfigFilter(filterName, configFilters);

  if (!configFilter) return null;

  const dataSource = getDataSource(configFilter.relatedDataSource, dataSources);
  const listOptions = getListOptions(sliceItems(dataSource?.features) as FeatureDc[], filterName, configFilters);
  const showMoreBtn = !!shownItems && dataSource?.features.length > shownItems;

  return (
    <>
      {listOptions.map((option, optionIndex) => {
        const isChecked =
          filters?.[filterName]?.value === undefined
            ? checkEqualOrIncludes(getConfigFilter(filterName, configFilters)?.defaultValue, option.value)
            : checkEqualOrIncludes(filters[filterName].value, option.value);

        return (
          <Checkbox
            key={optionIndex}
            label={option.text}
            checked={isChecked}
            className={isChecked ? "active" : ""}
            onChange={() => {
              const value = getFilterValue({
                filterName,
                selectedFilters: filters,
                configFilters,
                newValue: option.value,
              });

              changeFilters({ [filterName]: { value } } as SelectedFilters);
            }}
          />
        );
      })}
      {showMoreBtn && (
        <LegendToggler onClick={onShowMore} toggled={showMore}>
          {showMore ? t("hide") : t("showAll")}
        </LegendToggler>
      )}
    </>
  );
};
